import React, { useReducer, ReactNode, useMemo } from 'react';
import { createContext } from '../selectableContext';
import HomeActions from './actions';
import HomeReducer from './reducer';
import type { HomeFeedPaginationCursor } from './types';

export const HomeContext = createContext({});
export const initialHomeState = {
  category: 'recommended',
  currentFeaturedIndex: 0,
  displayOrder: 'desc',
  topMenuSection: 'start',
  feeds: [],
  feedPaginationCursor: null as HomeFeedPaginationCursor | null,
  feedsOutdated: false,
  fileUploadProgress: null,
  aiStoriesModalShown: false,
  chessPuzzleModalShown: false,
  chessOptionsTargetUser: null,
  dailyQuestionModalShown: false,
  groupIds: [],
  groupsObj: {},
  searchedGroupIds: [],
  loadMoreGroupsShown: false,
  isGroupsLoaded: false,
  previewGroups: [],
  inputModalShown: false,
  secretAttachmentUploadProgress: null,
  loadMoreButton: false,
  subFilter: 'all',
  submittingSubject: false,
  uploadingFile: false,
  leaderboardsObj: {},
  grammarLoadingStatus: '',
  grammarGenerationProgress: null as null | { current: number; total: number }
};

export function HomeContextProvider({ children }: { children: ReactNode }) {
  const [homeState, homeDispatch] = useReducer(HomeReducer, initialHomeState);
  const memoizedActions = useMemo(
    () => HomeActions(homeDispatch),
    [homeDispatch]
  );
  const contextValue = useMemo(
    () => ({
      state: homeState,
      actions: memoizedActions
    }),
    [homeState, memoizedActions]
  );

  return (
    <HomeContext.Provider value={contextValue}>
      {children}
    </HomeContext.Provider>
  );
}
